module.exports = __webpack_public_path__ + "img/portfolio-thumbnail_cocktailRoulette.ff86a60b.jpg";